var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "activity-form-container mt-3",
      attrs: { row: "", wrap: "" }
    },
    [
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$tc("Template", 1),
            value: _vm.activityTemplate,
            "variable-name": "activitiesTemplates",
            "input-type": "other",
            size: "medium"
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              options: _vm.activityTemplateOptions,
              "load-options": _vm.loadActivitiesTemplateOptions,
              normalizer: _vm.activityTemplateNormalizer,
              "value-format": "object",
              disableFuzzyMatching: ""
            },
            on: { input: _vm.updateActivityWithTemplate },
            model: {
              value: _vm.activityTemplate,
              callback: function($$v) {
                _vm.activityTemplate = $$v
              },
              expression: "activityTemplate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input-field", {
        attrs: { label: "", value: "", "input-type": "space", size: "small" }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("Title"),
          "variable-name": "title",
          "input-type": "text",
          size: "small",
          required: ""
        },
        model: {
          value: _vm.newActivity.title,
          callback: function($$v) {
            _vm.$set(_vm.newActivity, "title", $$v)
          },
          expression: "newActivity.title"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("DueDate"),
          "variable-name": "due_date",
          "input-type": "datetime",
          size: "small",
          min: _vm.dateNow
        },
        model: {
          value: _vm.newActivity.due_date,
          callback: function($$v) {
            _vm.$set(_vm.newActivity, "due_date", $$v)
          },
          expression: "newActivity.due_date"
        }
      }),
      _vm._v(" "),
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$t("ApprovalType"),
            "input-type": "other",
            size: "small",
            value: _vm.newActivity.auto_approval
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              value: _vm.newActivity.auto_approval,
              options: _vm.approvalType,
              disabled: !_vm.activityTemplate
            },
            on: {
              input: function($event) {
                return _vm.updateTasksApprovalType($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("Description"),
          "variable-name": "description",
          "input-type": "textarea",
          size: "large"
        },
        model: {
          value: _vm.newActivity.description,
          callback: function($$v) {
            _vm.$set(_vm.newActivity, "description", $$v)
          },
          expression: "newActivity.description"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a7bbe28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7bbe28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivityCreate/ActivityCreateForm.vue
// module id = null
// module chunks = 